module.exports = __webpack_public_path__ + "static/media/pin-danger.21c47c63.png";